import { Link } from 'react-router-dom';
import { useT } from '../i18n/index.ts';

/**
 * 404 page for routes not yet defined. Uses the design-system tokens so
 * it blends with the rest of the shell.
 */
export function NotFound(): JSX.Element {
  const t = useT();
  return (
    <section className="flex flex-col gap-4" data-testid="not-found">
      <h2 className="text-3xl font-semibold tracking-tight text-on-surface">
        {t('notfound.title')}
      </h2>
      <p className="text-sm text-outline">
        {t('notfound.body_prefix')}{' '}
        <Link to="/" className="text-primary underline-offset-4 hover:underline">
          {t('notfound.back')}
        </Link>
        .
      </p>
    </section>
  );
}
